import { msg } from "@lingui/core/macro";
import {
  dischargedPatientsQueryOptions,
  informationFieldConfigValueSchema,
  usePatientInformationFields,
} from "@/api/Patients";
import { PatientsTableContainer } from "./PatientsTableContainer";
import { useMemo } from "react";
import { getPatientFullName } from "@medoma/models/patients";
import { filterByNameTerms } from "@medoma/components/SearchField/searchUtils";
import { usePatientNameFilter } from "../PatientsContext";
import { useQuery } from "@tanstack/react-query";

export const DischargedPatients = () => {
  const { value: filter } = usePatientNameFilter();
  const {
    data: patients,
    isPending,
    isError,
    error,
  } = useQuery(dischargedPatientsQueryOptions({}));
  const { data: conditionalInformationFields } = usePatientInformationFields();

  const filteredPatients = useMemo(() => {
    if (!filter || !patients) {
      return patients;
    }

    return patients.filter((patient) =>
      filterByNameTerms(getPatientFullName(patient.name), filter),
    );
  }, [patients, filter]);

  const noResultsMessage =
    filteredPatients && patients && filteredPatients.length < patients.length
      ? msg`Det finns inga utskrivna patienter som matchar sökningen`
      : msg`Det finns inga utskrivna patienter`;

  const showPostDischargeProcessed =
    conditionalInformationFields?.PostDischargeProcessed !==
    informationFieldConfigValueSchema.enum.hidden;

  return (
    <PatientsTableContainer
      patients={filteredPatients}
      isPending={isPending}
      isError={isError}
      error={error}
      additionalColumns={["admittedAt", "dischargedAt"]}
      showNotifications={false}
      showPatientStatus={false}
      showPatientSignInStatus={false}
      showPrimaryResponsible={true}
      showPlaceOfAssessment={false}
      showPostDischargeProcessed={showPostDischargeProcessed}
      loadingMessage={msg`Hämtar utskrivna patienter`}
      errorMessage={msg`Kunde inte hämta utskrivna patienter`}
      noResultsMessage={noResultsMessage}
    />
  );
};
